var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGiwaPlus(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 36,
    viewBox: "0 0 32 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 12.3574H31.5V32.235C31.5 32.394 31.4244 32.5436 31.2963 32.6378L27.918 35.1225C27.7254 35.2642 27.3991 35.2864 27.1033 35.1419C25.7874 34.4993 22.6222 33.4455 16 33.4455C9.37782 33.4455 6.21262 34.4993 4.89668 35.1419L5.11609 35.5912L4.89668 35.1419C4.60086 35.2864 4.27461 35.2642 4.08196 35.1225L0.703748 32.6378C0.575644 32.5436 0.5 32.394 0.5 32.235V12.3574Z",
    fill: "#BDC7E4",
    stroke: "#1A2A53"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 5.63674C0 4.87685 0.29002 4.14634 0.90861 3.705C2.68732 2.43595 7.2422 0 16 0C24.7578 0 29.3127 2.43595 31.0914 3.705C31.71 4.14634 32 4.87685 32 5.63674V32.0579C32 32.9658 30.7365 33.5689 29.9465 33.1217C27.6556 31.8248 23.2806 30.1423 16 30.1423C8.71936 30.1423 4.34436 31.8248 2.05353 33.1217C1.26351 33.5689 0 32.9658 0 32.0579V5.63674Z",
    fill: "#1A2A53"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8008 10.0977V20.0977",
    stroke: "#ECF1FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8047 15.0977H20.8047",
    stroke: "#ECF1FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGiwaPlus);
export default __webpack_public_path__ + "static/media/giwa_plus.a4853403c3f6d527c3e0d2cf3f73f2d0.svg";
export { ForwardRef as ReactComponent };